import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Modal from "modules/Modal/Modal";
import dayjs from "dayjs";
import { schema, TimeEntryUpdateSchema } from "DDD/action-objects/TimeEntryUpdate";
import { useUpdateTimeEntry } from "hooks/timeTracking/useUpdateTimeEntry";
import EditTimeEntryForm from "./EditTimeEntryForm";

export default function EditTimeEntryModal({ open, onClose, entry }) {
  const [updateTimeEntry] = useUpdateTimeEntry();

  const defaultValues = {
    uuid: entry.uuid,
    startTime: new Date(entry.startTime),
    endTime: entry.endTime ? new Date(entry.endTime) : new Date(),
    notes: entry.notes,
    userId: entry.user?.id || null,
    jobPhaseId: entry.jobPhase?.id,
    timeBucketId: entry.timeBucket?.id,
  };

  const onSubmit = async (data: TimeEntryUpdateSchema) => {
    const result = await updateTimeEntry({
      variables: {
        input: {
          uuid: data.uuid,
          startTime: dayjs(data.startTime).format("YYYY-MM-DD HH:mm:ss"),
          endTime: dayjs(data.endTime).format("YYYY-MM-DD HH:mm:ss"),
          notes: data.notes,
          userId: data.userId,
          jobPhaseId: data.jobPhaseId,
          timeBucketId: data.timeBucketId,
        } as any,
      },
    });

    if (result.success) {
      onClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      styles={{ overflow: "auto", maxWidth: "1120px", height: "88vh", maxHeight: "980px" }}
    >
      <MDBox p={3} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <MDTypography variant="h6" mb={2}>
          Edit Time Entry
        </MDTypography>

        <EditTimeEntryForm
          onSubmit={onSubmit}
          onClose={onClose}
          entry={entry}
          defaultValues={defaultValues}
          schema={schema}
        />
      </MDBox>
    </Modal>
  );
}
